/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

export const SIGN_IN = 'SIGN_IN'
export const REQUEST_USER_PROFILE = 'REQUEST_USER_PROFILE'
export const LOAD_USER_PROFILE = 'LOAD_USER_PROFILE'
export const SIGN_OUT = 'SIGN_OUT'
export const ACCEPT_DISCLAIMER = 'ACCEPT_DISCLAIMER'

const initialState = {
    userProfile: {},
    loading: false,
}

export const security = (state = initialState, action) => {
    switch (action.type) {
        case SIGN_IN:
        case LOAD_USER_PROFILE:
            return {
                ...state,
                loading: false,
                userProfile: action.userProfile,
            }
        case SIGN_OUT:
            return initialState
        case REQUEST_USER_PROFILE: {
            return {
                ...state,
                loading: true,
            }
        }
        case ACCEPT_DISCLAIMER: {
            return {
                ...state,
                userProfile: {
                    ...state.userProfile,
                    disclaimerAccepted: true,
                },
            }
        }
        default:
            return state
    }
}